/**
 * Groups the customers by the first name Character
 * @param customerData - Customers Array
 */
import {businessCustomerValidation} from './validation';

export const groupAndSortCustomersByAlphabet = customerData => {
    const sortedCustomerData = {};
    customerData.forEach(customer => {
        if (sortedCustomerData[customer.name.charAt(0).toUpperCase()]) {
            sortedCustomerData[customer.name.charAt(0).toUpperCase()].push(customer);
        } else {
            sortedCustomerData[customer.name.charAt(0).toUpperCase()] = [customer];
        }
    });

    const orderedCustomerData = {};
    Object.keys(sortedCustomerData).sort().forEach(key => {
        orderedCustomerData[key] = sortedCustomerData[key];
    });
    return orderedCustomerData;
};

/**
 * Groups the customers by the first name Character
 * @param data - Customers Array
 * @param field - the filed to group by
 */
export const groupAndSortItemsByFieldCharacter = (data, field) => {
    const sortedCustomerData = {};
    data.forEach(item => {
        if (!item[field]) {
            return {'-': data};
        } if (sortedCustomerData[item[field].charAt(0).toUpperCase()]) {
            sortedCustomerData[item[field].charAt(0).toUpperCase()].push(item);
        } else {
            sortedCustomerData[item[field].charAt(0).toUpperCase()] = [item];
        }
    });

    const orderedCustomerData = {};
    Object.keys(sortedCustomerData).sort().forEach(key => {
        orderedCustomerData[key] = sortedCustomerData[key];
    });
    return orderedCustomerData;
};

export const groupAndSortItemsByFieldName = (data, field) => {
    const sortedCustomerData = {};
    data.forEach(item => {
        if (!item[field]) {
            return {Unknown: data};
        } if (sortedCustomerData[item[field]]) {
            sortedCustomerData[item[field]].push(item);
        } else {
            sortedCustomerData[item[field]] = [item];
        }
    });

    const orderedCustomerData = {};
    Object.keys(sortedCustomerData).sort().forEach(key => {
        orderedCustomerData[key] = sortedCustomerData[key];
    });
    return orderedCustomerData;
};

export const sortCustomers = customerData => customerData.sort(((customerA, customerB) => (customerA.name > customerB.name ? 1 : -1)));

export const sortItemByField = (data, field) => data.sort(((dataA, dataB) => (dataA[field] > dataB[field] ? 1 : -1)));

export const filterCustomers = (searchValue, customerData) => customerData.filter(customer => customer.name.toLowerCase().includes(searchValue) || customer.email.toLowerCase().includes(searchValue) || customer.company.toLowerCase().includes(searchValue));

export const findCustomerByEmail = (customers, email) => customers.find(customer => customer.email === email);

export const updateCustomer = (customers, customer) => {
    const customerId = customer.id;
    return customers.map(cr => {
        if (customerId) {
            return cr.id === customerId ? customer : cr;
        }
        // in the case where the customer that were are updating doesn't have id fallback to email.
        return cr.email === customer.email ? customer : cr;
    });
};

export const stopCustomerSyncing = (customers, customerEmail) => customers.map(customer => {
    if (customer.syncing & customer.email === customerEmail) {
        return {
            ...customer,
            syncing: false
        };
    }
    return customer;
});

/** ReMapping Functions **/

export const mapBusinessCustomersToCustomers = customers => customers.map(customer => ({
    id: customer.id,
    name: customer.representativeName,
    company: customer.companyName,
    companyId: customer.companyId,
    email: customer.representativeEmail,
    jobTitle: customer.representativeJobTitle,
    warning: businessCustomerValidation(customer)
}));

export const mapCsvDataToBusinessCustomers = csvCustomerData => csvCustomerData.map(
    item => ({
        companyName: item.CompanyName,
        creditLimit: +item.CreditLimit,
        trn: item.Trn,
        address: {
            line1: item.Address_Line1,
            line2: item.Address_Line2,
            parish: item.Address_Parish,
            city: item.Address_City,
            postalCode: item.Address_PostalCode,
        },
        representative: {
            firstName: item.Representative_FirstName,
            lastName: item.Representative_LastName,
            middleName: item.Representative_MiddleName,
            dateOfBirth: item.Representative_DOB,
            jobTitle: item.Representative_JobTitle,

            genderId: mapGenderValueToId(item.Representative_Gender),

            nationality: item[''],
            email: item.Representative_Email,
            contactNumber: item.Representative_ContactNumber
        }
    })
);

/**
 *  Maps the data returned by csv service to the schema used by the react components
 *  id(pin):"4631e87d-186b-4496-b059-08d77e7f607c"
 */
export const mapCsvCustomerToState = csvCustomerData => csvCustomerData.map(item => ({
    companyName: item.CompanyName,
    jobTitle: item.Representative_JobTitle,
    creditLimit: item.CreditLimit,
    trn: `${item.Trn}`,
    address: item.Address,
    representativeId: false,
    representativeEmail: item.Representative_Email,
    representativeContact: item.Representative_ContactNumber,
    representativeName: `${item.Representative_FirstName} ${item.Representative_LastName}`,
    representativeJobTitle: item.Representative_JobTitle,

    syncing: true, // this is true when the customer data is being uploaded.
    warning: ['Missing Fields:', '• Missing Certification of Incorporation', '• Missing Proof of Address for Business', '• Missing Tax Compliance Certificate'], // this flag is true when the customer does not have all its information.
}));

const mapGenderValueToId = value => {
    switch (value) {
    case 'Male':
        return 1;
    case 'Female':
        return 2;
    case 'NS':
    default:
        return 3;
    }
};
